import React from "react";
import { StriimMenuList, StriimMenuItem } from "@striim/striim-ui-v2";
import WithTooltip from "src/generic/tooltip/tooltip";

interface EditDropdownProps {
    onCut: () => void;
    onCopy: () => void;
    onPaste: () => void;
    onDelete: () => void;
    disableCut: boolean;
    disableCopy: boolean;
    disablePaste: boolean;
    disableDelete: boolean;
    setEditDropdownOpen: (open: boolean) => void;
}

const EditDropdown = ({
    onCut,
    onCopy,
    onPaste,
    onDelete,
    disableCut,
    disableCopy,
    disablePaste,
    disableDelete,
    setEditDropdownOpen
}: EditDropdownProps) => {
    return (
        <StriimMenuList>
            {WithTooltip(
                <StriimMenuItem
                    onClick={() => { if (!disableCut) { onCut(); setEditDropdownOpen(false); } }}
                    disabled={disableCut}
                    data-test-id="option-Cut"
                >
                    Cut
                </StriimMenuItem>,
                "Move component between flows of the same app",
                false,
                "left"
            )}
            {WithTooltip(
                <StriimMenuItem
                    onClick={() => { if (!disableCopy) { onCopy(); setEditDropdownOpen(false); } }}
                    disabled={disableCopy}
                    data-test-id="option-Copy"
                >
                    Copy
                </StriimMenuItem>,
                "Duplicate component's adapter & parser settings",
                false,
                "left"
            )}
            {WithTooltip(
                <StriimMenuItem
                    onClick={() => { if (!disablePaste) { onPaste(); setEditDropdownOpen(false); } }}
                    disabled={disablePaste}
                    data-test-id="option-Paste"
                >
                    Paste
                </StriimMenuItem>,
                "Paste copied or cut component",
                false,
                "left"
            )}
            {WithTooltip(
                <StriimMenuItem
                    onClick={() => { if (!disableDelete) { onDelete(); setEditDropdownOpen(false); } }}
                    disabled={disableDelete}
                    data-test-id="option-Delete"
                >
                    Delete
                </StriimMenuItem>,
                "Drop component",
                false,
                "left"
            )}
        </StriimMenuList>
    );
};

export default EditDropdown;
